import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";

const DeleteNoteMutation = graphql(`
  mutation DeleteNote($id: ID!) {
    deleteNote(id: $id)
  }
`);

export function useDeleteNote() {
  const [result, deleteNoteMutation] = useMutation(DeleteNoteMutation);
  const [error, setError] = useState<Error | null>(null);

  const deleteNote = useCallback(
    async (id: string) => {
      try {
        const response = await deleteNoteMutation({ id });
        if (response.error) {
          throw response.error;
        }
        return response.data?.deleteNote;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [deleteNoteMutation],
  );

  return { deleteNote, result, error };
}
